export const SUPPORTED_LANGUAGES = ['it'];
export const APP_DEFAULT_LANGUAGE = 'it';
export const MIN_PREMIUM_THRESHOLD = -5;
export const MAX_PREMIUM_THRESHOLD = 5;
export const HEADER_X_TOKEN = 'X-Token';
export const HEADER_X_REFRESH_TOKEN = 'X-Refresh-Token';
export const HEADER_GWCOOKIE = 'GWCOOKIE';
export const DEFAULT_PARTNERSHIP_ID_VERTIWEB = '0099';
export const DEFAULT_PARTNERSHIP_SHORTNAME_VERTIWEB = 'VRW';
export const RISKHOME = 'HOME';
export const COOKIE_PARTNERSHIP_ID = 'ptId';
export const COOKIE_PARTNERSHIP_SHORT_NAME = 'alliance';
export const PARTNERSHIP_CUSTOM_BEHAVIOR = ['0281', '4013'];
